import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$guid/edit')({
  component: () => <div>Hello /_authenticated/user/$guid/edit!</div>,
})
